<template>
    <div style="height:auto;">
        <el-dialog :width="modelObj.width"  :visible.sync="dialogShow"
                   :center="modelObj.center"  :show-close="false"  >
                <div slot="title"   >
                    <div class="text-center font-weight-bold text-l-size border-bottom  padding-b">
                        温馨提示
                    </div>

                </div>
            <div class="padding-y text-left">
                本栏目试题请同学们自行在纸上进行解答，完成后可对比答案解析，请同学们提前把“显示答案”选项关闭哦！
            </div>
            <div class="text-right">
                <el-button type="primary" size="medium" class="rounded-small" @click="dialogShow=false">已知晓</el-button>
            </div>
        </el-dialog>
        <div>
            <!--试题中心-->
            <div class="secondary-header-content ">
                <div class="  delFloat" style="width: 1000px; margin: 10px auto 0 auto">
                    <p style="margin:8px 10px;font-size: 16px" class="float-left">
                        学科
                    </p>
                    <div class="float-left">
                        <el-button v-for="item in subjectList" :key="item.subjectId" size="small" :type="getSubjectId===item.subjectId?'primary':''" @click="selectSubject(item.subjectId,item.subjectName)" style="border: none;margin: 5px">
                           <span class="text-d-size">
                               {{item.subjectName}}
                           </span>
                        </el-button>
                    </div>
                </div>
            </div>
            <div class="content-container">
                <!--左侧栏-->
                <div class="knowledgeTree padding-top    position-relative">
                    <div v-show="!leftLoading">
                        <el-popover
                                placement="bottom"
                                width="280"
                                trigger="hover">
                            <div style="max-height: calc(100vh - 134px);overflow-y: auto;" class="public_scroll_bar">
                                <div>
                                    <p style="margin: 10px;font-size: 16px">
                                        版本
                                    </p>
                                    <el-button  :type="selectModeId===item.versionId?'primary':''" @click="selectVersion(item.versionId)"
                                                style="border: none;margin: 10px"
                                                v-for="item in getModelAllList" :key="item.versionId">
                                        {{item.versionName}}
                                    </el-button>
                                </div>
                                <div>
                                    <p style="margin: 10px;font-size: 16px">
                                        模块
                                    </p>
                                    <el-button :type="getModelChildId===item.moduleId?'primary':''" @click="selectModel(item.moduleId,item.moduleName)" style="border: none;margin: 10px" v-for="item in getModelChildList" :key="item.moduleId">
                                        {{item.moduleName}}
                                    </el-button>
                                </div>
                            </div>
                            <el-button type="primary" slot="reference" >
                                <span>{{versionName}}</span>/ <span>{{modelName}}</span>      <i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                        </el-popover>
                        <!--左侧目录-->
                        <div class="padding-small">
                            <div class="elTreeBox public_scroll_bar">
                                <el-tree
                                        class="margin-top"
                                        @current-change="changeNode"
                                        :data="chapterList"
                                        default-expand-all
                                        node-key="id"
                                        ref="tree"
                                        accordion
                                        :highlight-current=true
                                        :props="defaultProps">
                                    <!--嵌套其中的值，scope的data可以获得当前节点的值，这样写实现嵌套效果-->
                                    <div slot-scope="{ data }" style="width: 180px;">
                                        <el-tooltip placement="right-start" v-if="data.name.length>10" :content="data.name">
                                            <div class="text-ellipsis" :class="getChapterId===data.id?'activeTree':''">
                                                {{data.name}}
                                            </div>
                                        </el-tooltip>
                                        <div v-else  :class="getChapterId===data.id?'activeTree':''">
                                            {{data.name}}
                                        </div>
                                    </div>
                                </el-tree>
                            </div>
                        </div>
                    </div>
                    <loading :show="leftLoading" width="280px"></loading>
                </div>
                <div class="test-show">
                    <!--右上栏-->
                    <div class="question-list position-relative"  style="min-height: 98px;">
                        <div class="selection-panel" v-show="!rightQxLoading">
                            <p>
                                <label>题型：</label>
                                <span>
                                <el-button v-for="(item,index) in testType"
                                           :type="typeId===item.typeId?'primary':''"
                                           :key="index" @click="selectType(item.typeId)">
                                    {{item.typeName}}
                                </el-button>
                            </span>
                            </p>
                            <p>
                                <label>难度：</label>
                                <span>
                                <el-button v-for="(item,index) in difficulty"
                                           :type="item.difficulty===difficultyId?'primary':''"
                                           :key="index"
                                           @click="selectDifficult(item.difficulty)">
                                    {{item.text}}
                                </el-button>
                            </span>
                            </p>
                        </div>
                        <loading :show="rightQxLoading" width="880px"></loading>
                    </div>
                    <!--右下栏-->
                    <div class="question-list">
                        <div class="flex-box mr-bottom">
                            <div style="line-height: 32px;">
                                <div>
                                    <el-radio-group v-model="sortId" @change="selectSort">
                                        <el-radio-button v-for="item in sortList"
                                                         :label="item.sorted" :key="item.sorted">{{item.text}}
                                            <i class="iconfont icon-jiantou-xia"></i>
                                        </el-radio-button>
                                    </el-radio-group>

                                    <span style="float: right">
                                        <el-checkbox v-model="checked" style="font-size: 18px"
                                                     @change="showAnswer">
                                            显示答案
                                        </el-checkbox>
                                        <span style="margin-right: 20px">
                                            共计 <i style="color: dodgerblue"> {{totalItem}} </i>道题
                                        </span>

                                    </span>
                                </div>
                            </div>
                        </div>
                        <!--内容开始-->
                        <div class="test-content-list position-relative" style="min-height: 300px;" >
                            <div v-show="!questionLoading">
                                <div v-for="item in questionList"  :key="item.id" class="margin-top questionContent" >
                                    <div  class="parentQuestion" v-if="item.subQuestions&&item.subQuestions.length>0" v-html="item.content">
                                    </div>
                                    <div v-if="item.subQuestions&&item.subQuestions.length>0" v-for="itemQuestion in item.subQuestions" :key="itemQuestion.id">
                                        <div class="content" @click="getSolution(itemQuestion.id)" >
                                            <div class="question-box">
                                                <div>
                                                    <div class="selectedmask" style="display: none;"></div>
                                                    <div class="title" v-html="itemQuestion.content"></div>
                                                    <div class="choices">
                                                        <div class="ant-row" v-show="itemQuestion.optionA!==null">
                                                            <div class="ant-col ant-col-24">A.
                                                                <div class="inline" v-html="itemQuestion.optionA"></div>
                                                            </div>
                                                            <div class="ant-col ant-col-24">B.
                                                                <div class="inline" v-html="itemQuestion.optionB">

                                                                </div>
                                                            </div>
                                                            <div class="ant-col ant-col-24">C.
                                                                <div class="inline" v-html="itemQuestion.optionC">

                                                                </div>
                                                            </div>
                                                            <div class="ant-col ant-col-24">D.
                                                                <div class="inline" v-html="itemQuestion.optionD">

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div  class="solution" v-if="solutionId===itemQuestion.id||solutionShow">
                                            <div  class="solution-detail">
                                                <div  class="solution-head">【答案】</div>
                                                <div class="solution-explain" v-html="itemQuestion.answer">
                                                </div>
                                            </div>
                                            <div class="solution-detail">
                                                <div class="solution-head">【解析】</div>
                                                <div class="solution-explain" v-html="itemQuestion.answerExplanation">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-show="item.subQuestions.length<1">
                                        <div class="content" @click="getSolution(item.id)" >
                                            <div class="question-box">
                                                <div>
                                                    <div class="selectedmask" style="display: none;"></div>
                                                    <div class="title" v-html="item.content"></div>
                                                    <div class="choices">
                                                        <div class="ant-row" v-show="item.optionA!==null">
                                                            <div class="ant-col ant-col-24">A.
                                                                <div class="inline" v-html="item.optionA"></div>
                                                            </div>
                                                            <div class="ant-col ant-col-24">B.
                                                                <div class="inline" v-html="item.optionB">

                                                                </div>
                                                            </div>
                                                            <div class="ant-col ant-col-24">C.
                                                                <div class="inline" v-html="item.optionC">

                                                                </div>
                                                            </div>
                                                            <div class="ant-col ant-col-24">D.
                                                                <div class="inline" v-html="item.optionD">

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div><!---->
                                                </div>
                                            </div>
                                        </div>
                                        <div  class="solution" v-if="solutionId===item.id||solutionShow">
                                            <div  class="solution-detail">
                                                <div  class="solution-head">【答案】</div>
                                                <div class="solution-explain" v-html="item.answer">
                                                </div>
                                            </div>
                                            <div class="solution-detail">
                                                <div class="solution-head">【解析】</div>
                                                <div class="solution-explain" v-html="item.answerExplanation">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="margin-y text-center">
                                    <el-pagination
                                            :hide-on-single-page="true"
                                            @current-change="handleCurrentChange"
                                            :current-page.sync="currentPage"
                                            :page-size="20"
                                            layout="prev, pager, next, jumper"
                                            :total="totalItem">
                                    </el-pagination>
                                </div>
                            </div>
                            <loading :show="questionLoading" width="880px"> </loading>
                            <empty v-show="!questionLoading&&questionList.length<1" :textSize="20" content="未查出相关题目"></empty>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {
        accordingChapterSQuestion,
        accordingGetQuestionData,
        accordingGetQuestionList,
        accordingQuestionHardlevel,
        accordingSubjectSsVersion,
        accordingVersionSsChapter,
        questionOrderBy,
        questionSubject, selectQuestionAddStl,
        selectQuestionDelBasket
    } from "../../config";
    export default {
        name: "testCenter",
        data() {
            return {
                modelObj:{
                    title:'',
                    width:"350px",
                    center:true,
                    type:'zzz'
                },
                dialogShow:false,
                //加载试题篮内容
                loadingBasket:false,
                //右上加载
                rightQxLoading:false,
                //右侧题目内容loading
                questionLoading:false,
                //左侧目录loading
                leftLoading:false,
                //获取选择的版本名称
                versionName:'',
                //获取选择的模块名称
                modelName:'',
                //获取列表上方的排序方式
                questionSortType:[],
                //获取版本列表
                getModelAllList:[],
                //获取版本id
                selectModeId:'',
                //获取模块列表
                getModelChildList:[],
                //获取模块id
                getModelChildId:'',
                //获取章节list
                chapterList:[],
                //获取所选中的章节id
                getChapterId:'',
                radio1: '更新时间',
                input: '',
                checked: true,
                subjectList:[],
                defaultProps: {children: 'children',label: 'name'},
                testType: [],
                difficulty: [],
                solutionId:'',
                //默认选中的左侧目录
                getSubjectId:'',
                //获取所选择的题型的id
                typeId:null,
                //获取所选择的题目难度id
                difficultyId:0,
                //获取试题的排序方式（更新时间，组卷方式）
                sortList:[],
                //获取选中的排序方式
                sortId:'',
                //分页当前页
                currentPage:1,
                totalItem:0,
                //获取是题目列表
                questionList:[],
                //控制显示当前题目的所有答案
                solutionShow:true,
                subjectName:'',
                //获取试题篮length
                testBasket:[]
            }
        },
        mounted(){
           this.dialogShow=true;
          if(this.$route.path==='/studentAndTeacherPlatform/testCenter'){
              document.querySelector('html').style.backgroundColor='#f1f5f8';
          }
          //查出学科默认选择所有条件的第一项
          this.getSubjectlists();
          //困难度
          this.getQuestionDifficult();
          //排序方式
          this.getSortlist();
        },
        beforeDestroy(){
            document.querySelector('html').style.backgroundColor='#ffffff';
        },
        methods:{
            //分页
            handleCurrentChange(){
                window.scrollTo(0,0);
                this.getQuestionListContent();
            },
            //添加试题
            async addQuestionBasket(val){
                let result=await selectQuestionAddStl(this.getSubjectId,[val]);
                if(result.status){

                }
            },
            //选择试题篮触发显示试题框
            showQuestionBasket(){
                this.defaultQuestionLan();
            },
            //删除试题篮
            async delTagBasket(val,type){
                if(type!==undefined){
                    val=this.testBasket.filter((valSx)=>{
                        return valSx===valSx.ids;
                    })
                }
                let result=await selectQuestionDelBasket(val);
                if(result.status){
                    this.defaultQuestionLan();
                }else{

                }
            },
            //默认查出试题篮
            async defaultQuestionLan(){
                this.loadingBasket=true;
                let result=await accordingGetQuestionData(this.getSubjectId);
                if(result.status){
                    this.loadingBasket=false;
                    // "quesCount": 6,
                    //     "typeName": "选择题",
                    //     "Ids": "3,1,6,4,2,5"
                    this.testBasket=result.data;
                }else{
                    this.loadingBasket=false;
                }
            },
            //显示答案
            showAnswer(val){
                this.solutionShow=val;

            },
            //根据id获取试题列表
            async getQuestionListContent(){
                this.questionLoading=true;
                let result=await accordingGetQuestionList(this.getChapterId,this.typeId,this.difficultyId,this.sortId,this.currentPage,20);
                if(result.status){
                    this.questionLoading=false;
                    this.totalItem=result.data.totalRecords;
                    this.questionList=result.data.data;
                }else{
                    this.questionLoading=false;
                }
            },
            //选择题目困难度
            selectDifficult(val){
                this.difficultyId=val;
                this.currentPage=1;
                this.getQuestionListContent();
            },
            //选择题目类型
            selectType(val){
                this.typeId=val;
                this.currentPage=1;
                this.getQuestionListContent();
            },
            //获取列表上方的排序方式
            async getSortlist(){
                let result=await questionOrderBy();
                if(result.status){
                    this.sortList=result.data;
                }else{

                }
            },
            //选择排序
            selectSort(){
                this.currentPage=1;
                this.getQuestionListContent();
            },
            //获取题型
            async getQuestionType(){
                this.rightQxLoading=true;
                let result=await accordingChapterSQuestion(this.getChapterId);
                if(result.status){
                    this.rightQxLoading=false;
                    this.testType=result.data;
                    this.typeId=result.data[0].typeId;
                }else{
                    this.rightQxLoading=false;
                }
            },
            //获取试题难度
            async getQuestionDifficult(){
                let result=await accordingQuestionHardlevel();
                if(result.status){
                    this.difficulty=result.data;
                    this.difficultyId=result.data[0].difficulty;
                }else{

                }
            },
            //获取当前tree节点所选择的内容
            changeNode(val){
                this.getChapterId=val.id;
                this.getQuestionType();
                this.currentPage=1;
                this.getQuestionListContent();
            },
            //选择模块
            selectModel(valId,valName){
                this.getModelChildId=valId;
                this.modelName=valName;
                this.searchChapter();
            },
            //根据模块id查出章节
            async searchChapter(){
                this.leftLoading=true;
                let result=await accordingVersionSsChapter(this.getModelChildId);
                if(result.status){
                    this.leftLoading=false;
                    //我是查出的章节
                    this.chapterList=result.data;
                    this.getChapterId=result.data[0].id;
                    this.currentPage=1;
                    this.getQuestionListContent();
                    //根据章节id查出题目类型列表
                    this.getQuestionType();
                }else{
                    this.leftLoading=false;
                }
            },
            //选择版本
            async selectVersion(val){
                let zhi=this.getModelAllList.filter((valModel)=>{
                    return val===valModel.versionId;
                });
                this.selectModeId=zhi[0].versionId;
                this.versionName=zhi[0].versionName;
                this.getModelChildList=zhi[0].modules;
                this.getModelChildId=this.getModelChildList[0].moduleId;
                this.modelName=this.getModelChildList[0].moduleName;
                this.searchChapter();
            },
            //选择学科
            selectSubject(val,valName){
                this.getSubjectId=val;
                this.subjectName=valName;
                //查出试题篮中的内容

                //查出左侧目录
                this.getLeftDirection();
            },
            getSolution(val){
                if(this.solutionId===val){
                    this.solutionId='';
                }else{
                    this.solutionId = val;
                }
            },
            //获取学科
            async getSubjectlists(){
                let result=await questionSubject();
                if(result.status){
                    this.subjectList=result.data;
                    this.getSubjectId=result.data[0].subjectId;
                    this.subjectName=result.data[0].subjectName;

                    this.getLeftDirection();
                }else{

                }
            },
            //默认选择学科的第一项查出左侧目录相关数据
            async getLeftDirection(){
                let result=await accordingSubjectSsVersion(this.getSubjectId);
                if(result.status){
                    this.getModelAllList=result.data;
                    this.selectModeId=result.data[0].versionId;
                    this.versionName=result.data[0].versionName;
                    this.getModelChildList=result.data[0].modules;
                    this.getModelChildId=this.getModelChildList[0].moduleId;
                    this.modelName=this.getModelChildList[0].moduleName;
                    this.searchChapter();
                }
            }
        }
    }
</script>
<style lang="scss">
    .el-dialog__body{
        padding-top:0 !important ;
    }
    .knowledgeTree {
        /*.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {*/
        /*    color: #03a9f4;*/
        /*}*/

        .el-tree-node__label {
            overflow: hidden;
            word-break: keep-all;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
    }
</style>
<style scoped lang="scss">
    .activeTree{
        color:#03a9f4;
    }
    .secondary-header-content {
        left: 0;
        top: 0;
        position: fixed;
        z-index: 5;
        width: 100%;
        background: #ffffff;
        -webkit-box-shadow: 0 0 6px 0 rgb(73 83 98 / 12%);
        box-shadow: 0 0 6px 0 rgb(73 83 98 / 12%);
        height: 63px;
        border-top: 1px solid #999;
        margin-top: 60px;
        .secondary-header-menu{
            width:1200px;
            margin:0 auto 0 auto;
            background: #ffffff;
            height:63px;
            .course_select {
                width: 280px;
                float: left;
                cursor: pointer;
                background-color: #0a93fc;
                color: #fff;
                text-align: center;
                font-size: 16px;
                z-index: 500;
                height: 60px;
                span {
                    line-height: 60px;
                }
            }

            .secondary-header-menu-section {
                .secondary-header-menu-item {
                    font-size: 16px;
                    color: #666;
                    padding: 0 20px;
                    float: left;
                    height: 60px;
                    line-height: 60px;

                    :first-child {
                        padding-left: 10px;
                    }
                }
            }

            .question-basket {
                width: 148px;
                height: 32px;
                line-height: 30px;
                border: 1px solid #e8e8e8;
                margin-top: 14px;
                text-align: center;
                color: #0a93fc;
                cursor: pointer;
            }

            .my-collection {
                line-height: 60px;

                span {
                    margin-right: 20px !important;
                }
            }
        }

    }

    .content-container {

        background-color: #f1f5f8;
        width: 1200px;
        margin:70px auto 0 auto;
        height: calc(100vh - 134px);

        .knowledgeTree {
            position: fixed;

            background: #ffffff;
            width: 280px;
            height: calc(100vh - 156px);
            float: left;
            margin-right: 30px;
            -webkit-box-shadow: 0 0 6px 0 rgb(73 83 98 / 12%);
            box-shadow: 0 0 6px 0 rgb(73 83 98 / 12%);
            .el-button {
                width: 240px;
                margin: 0 20px;
            }
            .elTreeBox{
                height: calc(100vh - 235px);
                overflow-y: auto;
            }
        }

        .test-show {
            margin-left: 310px;

            width: 880px;
            .question-list {
                margin: 13px 0 0 0;
                -webkit-box-shadow: 0 0 6px 0 rgb(73 83 98 / 12%);
                box-shadow: 0 0 6px 0 rgb(73 83 98 / 12%);
                padding:10px;
                background: #ffffff;
                .selection-panel {
                    p {
                        margin: 10px;

                        span {
                            .el-button {
                                display: inline;
                                border: none;
                                //background-color: transparent;
                                cursor: pointer;
                                padding: 5px 10px;
                                outline: none;
                                line-height: 1;
                            }
                        }
                    }

                }

                .flex-box {
                    -webkit-box-pack: justify;
                    -ms-flex-pack: justify;
                    justify-content: space-between;
                    margin-top: 50px;
                    .el-input {
                        width: 200px;
                        margin-left: 10px;
                    }
                    span {
                        .el-checkbox__label {
                            font-size: 18px !important;
                        }
                    }
                }
            }
        }
        .test-content-list {
            margin-top: 20px;
            .questionContent:hover{
                /*border: 1px solid #209cff;*/
                animation: commOptionHotJob .4s ease-out forwards;
            }
            .parentQuestion{
                border-bottom: 1px solid #d3d5dd;
                padding: 10px;
                cursor: pointer;
            }
            .parentQuestion:before{
                content: "\3010\203B\7EC4\9898\9898\5E72\203B\3011";
                color: #f16269;
            }
            .content {
                padding: 20px;
                border: 1px solid transparent;
                -webkit-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;
                user-select: none;
                line-height: 30px;
                cursor: pointer;

            }
            .solution{
                background: #f1f5f8;
                border-radius: 4px;
                margin: 20px 0 20px 0;
                padding: 10px;
                font-size: 14px;
                .solution-detail {
                    width: 100%;
                    display: -webkit-box;
                    display: -ms-flexbox;
                    display: flex;
                    .solution-head {
                        width: 70px;
                        white-space: nowrap;
                        font-weight: 600;
                    }
                }
            }
            .wrap-class-grade{
                width: 100%;
                color: #888;
                margin-top: 10px;
                display: flex;
                justify-content: space-between;
                .statistics {
                    display: flex;
                    align-items: center;
                    span{
                        padding-right: 20px;
                    }
                }
               .buttons {
                  .button {
                       display: inline-block;
                       // width: 36px;
                       height: 36px;
                       border-radius: 4px;
                       margin-right: 10px;
                       border: 1px solid transparent;
                      cursor: pointer;
                      i{
                          font-size: 26px;
                          color: #0390f4;
                      }
                   }
                   .el-button {
                       display: block;
                       //width: 36px;
                       height: 36px;
                       border-radius: 4px;
                       margin-right: 10px;
                       border: 1px solid transparent;
                   }
               }

            }

        }

    }
</style>
